import * as types from './mutation-types'

export default {
  [types.SET_PATIENT] (state, data) {
    state.patient = data
  },
  [types.SET_APPOINTMENT] (state, data) {
    state.appointment = data
  }
}
